import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-blog-cta',
    templateUrl: './blog-cta.component.html',
    styleUrls: ['./blog-cta.component.scss']
})
export class BlogCtaComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
